import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../css/UserInfo.css";
import { useHistory } from "react-router-dom";
import {
  selectInitialUserInfo,
  selectOtherUserInfo,
  userInfoError,
  userInfoUpdatedTime,
  userInfoLoading,
  fetchAsyncUserInfo,
  fetchAsyncSearchUsers,
  selectSearchUserInfo,
} from "./UserInfoSlice";
import { UserInfoData, ModalProps } from "./UserInfoType";
import UserInfoSearchView from "./UserInfoSearchView";
import { DateConverter } from "../../utils/DateConverter";

const UserInfo: React.FC = () => {
  //ページネーション
  const [page, setPage] = useState<number>(1);
  //storeにアクセス
  //レンタル中情報
  const initialUserInfoData = useSelector(selectInitialUserInfo);
  const otherUserInfoData = useSelector(selectOtherUserInfo);
  //エラー時メッセージ
  const userInfoErrorMsg = useSelector(userInfoError);
  //ロード中判定
  const userInfoLoadingJudge = useSelector(userInfoLoading);
  //データ取得時間
  const userInfoGetTime = useSelector(userInfoUpdatedTime);
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState<UserInfoData | null>(null);
  const [modal, setModal] = useState<boolean>(false);

  //モーダル制御
  const handleModal = (item: UserInfoData) => {
    setSelectedItem(item);
    setModal(!modal);
  };

  const navigate = useHistory();
  // モーダルコンポーネント
  const Modal: React.FC<ModalProps> = ({ item }) => (
    <div className="modal">
      rent_id : {item.rent_id} 名前 : {item.user_name}
      <br />
      order_id : {item.order_id}
      <br />
      cust_code : {item.cust_code}
    </div>
  );

  const history = useHistory();
  //詳細ページに飛ぶ
  const jumpToDetail = (item: any) => {
    history.push("/User_detail", { user_id: item });
  };
  //データ取得
  useEffect(() => {
    //状態が初期値だったらAPIリクエスト
    if (page === 1) {
      if (initialUserInfoData === null) {
        dispatch(fetchAsyncUserInfo(1));
      }
    } else {
      dispatch(fetchAsyncUserInfo(page));
    }
  }, [page]);

  const [selectedOption, setSelectedOption] = useState<string>("検索項目");
  const [searchWord, setSearchWord] = useState<string>("");
  const searchUserInfoData = useSelector(selectSearchUserInfo);

  const searchData = searchUserInfoData?.data?.result?.data;
  const searchDataArray = Array.isArray(searchData);

  useEffect(() => {
    if (selectedOption && searchWord) {
      dispatch<any>(
        fetchAsyncSearchUsers({
          page: 1,
          option: selectedOption,
          word: searchWord,
        })
      );
    }
  }, [dispatch]);

  return (
    <div className="position_row">
      <div className="user_info_container">
        {modal && <Modal item={selectedItem!} />}
        <h1 className="user_info_title">ユーザー情報</h1>
        <UserInfoSearchView />
        <div className={page === 1 ? "time" : "time invisible"}>
          最終更新時間 : {userInfoGetTime}
        </div>
        <table className="item_container">
          <thead>
            <tr key={"user_info_title"} className="user_info_item_container">
              <td className="item">ユーザNo.</td>
              <td className="item">メールアドレス</td>
              <td className="item">名前</td>
              <td className="item">電話番号</td>
              <td className="item">認証</td>
              <td className="item">生年月日</td>
              <td className="item">年齢</td>
              <td className="item">性別</td>
              <td className="item">住所</td>
              <td className="item">登録日</td>
              <td className="item">クーポン</td>
            </tr>
          </thead>
          <tbody>
            {searchData === undefined &&
              (page === 1 ? initialUserInfoData : otherUserInfoData)?.map(
                (item) => (
                  <tr key={item.user_id} className="user_info_item_container">
                    <td className="item">{item.user_id}</td>
                    <td
                      className="item"
                      onDoubleClick={() => jumpToDetail(item.user_id)}>
                      {item.email}
                    </td>
                    <td
                      className="item"
                      onDoubleClick={() => jumpToDetail(item.user_id)}>
                      {item.family_name} {item.first_name}
                    </td>
                    <td className="item">{item.phone_number}</td>
                    <td className="item">{item.status}</td>
                    <td className="item">{item.date_of_birth}</td>
                    <td className="item">{item.age}</td>
                    <td className="item">{item.gender}</td>
                    <td className="item">{item.address}</td>
                    <td className="item">
                      {DateConverter(item.account_creation_date)}
                    </td>
                    <td className="item">
                      {item.coupon_id_list
                        .toString()
                        .split(",")
                        .join(", ")
                       }
                    </td>
                  </tr>
                )
              )}
            {searchDataArray &&
              searchData !== undefined &&
              searchData.length !== 0 &&
              searchData.map((item) => (
                <tr key={item.user_id} className="user_info_item_container">
                  <td className="item">{item.user_id}</td>
                  <td
                    className="item"
                    onDoubleClick={() => jumpToDetail(item.user_id)}>
                    {item.email}
                  </td>
                  <td
                    className="item"
                    onDoubleClick={() => jumpToDetail(item.user_id)}>
                    {item.family_name} {item.first_name}
                  </td>
                  <td className="item">{item.phone_number}</td>
                  <td className="item">{item.status}</td>
                  <td className="item">{item.date_of_birth}</td>
                  <td className="item">{item.age}</td>
                  <td className="item">{item.gender}</td>
                  <td className="item">{item.address}</td>
                  <td className="item">
                    {DateConverter(item.account_creation_date)}
                  </td>
                  <td className="item">
                    {item.coupon_id_list
                      .toString()
                      .split(",")
                      .join(", ")
                    }
                  </td>
                </tr>
              ))}
            {searchDataArray && searchData.length === 0 && (
              <tr className="search_none_msg_container">
                <td colSpan={11}>
                  <span className="search_none_msg">
                    検索結果が見つかりません
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="user_info_footer">
          <button
            onClick={() => setPage((prevPage) => prevPage - 1)}
            disabled={page === 1}>
            前へ
          </button>
          <span className="user_info_page">{page}</span>
          <button onClick={() => setPage((prevPage) => prevPage + 1)}>
            次へ
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
